<ion-content [style.max-width]="max_width" style="--background: inherit;">
  <div class="container">
    <div class="modal-content" [style.background]="backgroundColor">
      <div class="title-bold" style="color: #6E00C9; ">
        {{ title }}
      </div>

      <div class="body-sm-regular" style="margin: 20px 0;" [innerHTML]="safeDescription">
      </div>



      <app-input-prefix-field [validator]="validator['value']" [prefix]="prefixInput" [(ngModel)]="value" [placeholder]="placeholderInput"
        [mask]="maskInput" [thousandSeparator]="thousandSeperatorInput" [title]="titleInput">
      </app-input-prefix-field>



      <div class="button-container">
        <div *ngIf="showCancelButton === true" (click)="dismissModal('Cancel')" class="button body-md-semibold"
          style="border: 1px solid var(--green); color: var(--green);">
          {{ cancelText }}
        </div>

        <div *ngIf="showConfirmButton === true" (click)="dismissModal('Confirm')" class="button body-md-semibold"
          style="background-color: var(--green); color: white;">
          {{ confirmText }}
        </div>
      </div>
    </div>

  </div>
</ion-content>
